import { CoreUiInteractionEvent, UiInteraction } from "@obg/ngx.core";

import { TrackingContext } from "../tracking/tracking.model";

export const BETA_BADGE_UI_INTERACTION: UiInteraction = {
	event: CoreUiInteractionEvent.Navigate,
	context: TrackingContext.HeaderInteractionContext,
	data: {
		Direction: "New to Old",
		event: "WebsiteToggle",
	},
};
